















































































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
import Vue from "vue";

import { State, Action, Mutation } from "vuex-class";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import moment from "moment";
import momentTz from "moment-timezone";

import SudokuService from "../../../services/sudoku";
import { User } from "../../../services/sudoku/sudoku.types";

import { debounceFn } from "../../../utils/debounceDec";

const namespace = "sudoku";

@Component
export default class Players extends Vue {
  ss = SudokuService;
  @Prop()
  filters = {
    name: "",
    id: ""
  };

  indicators = {
    userLoading: false,
    creatingUser: false,
    updateingUser: false,
    deletingUser: false
  };

  dialog = false;
  createUserDialog = false;

  get getLoading() {
    return Object.values(this.indicators).filter(v => !!v).length > 0;
  }

  headers = [
    { text: "ID", value: "id" },
    {
      text: "Username",
      align: "start",
      sortable: false,
      value: "name"
    },
    { text: "Score", value: "score" },
    { text: "Level", value: "level" },
    { text: "Timezone", value: "timeZone" },
    { text: "Vip", value: "vip" },
    { text: "OS", value: "os" },
    { text: "Push Status", value: "pushStatus" },
    { text: "AFI", value: "appsFlyerId" },
    { text: "Actions", value: "actions", sortable: false }
  ];
  users: User[] = [];
  editedIndex = -1;
  editedItem = {};
  defaultItem = {};
  error: Error | null = null;
  formTitle = "";

  mounted() {
    this.getUsers();
  }

  @Watch("filters", { deep: true })
  @debounceFn(1000)
  async getUsers() {
    this.indicators["userLoading"] = true;
    this.error = null;

    const filters = Object.entries(this.filters)
      .filter(([name, v]) => !!v.length)
      .reduce((acc, [n, v]) => ({ ...acc, [n]: v }), {});

    return SudokuService.getUsers(filters)
      .then((users: User[]) => (this.users = users))
      .catch((e: Error) => (this.error = e))
      .finally(() => (this.indicators["userLoading"] = false));
  }

  editItem(item: User) {
    this.editedIndex = this.users.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  createItem(item: User) {
    this.indicators["creatingUser"] = true;
    this.ss
      .createUser(item)
      .then(this.getUsers)
      .then(this.reset)
      .catch(error => (this.error = error))
      .finally(() => (this.indicators["creatingUser"] = false));
  }

  updateItem(item: User) {
    this.indicators["updateingUser"] = true;
    this.ss
      .updateUser(item)
      .then(this.getUsers)
      .then(this.reset)
      .catch(error => (this.error = error))
      .finally(() => (this.indicators["updateingUser"] = false));
  }

  deleteItem(item: User) {
    if (confirm("Are you sure you want to delete this item?")) {
      this.indicators["deletingUser"] = true;
      this.ss
        .deleteUser(item)
        .then(this.getUsers)
        .then(this.reset)
        .catch(error => (this.error = error))
        .finally(() => (this.indicators["deletingUser"] = false));
    }
  }

  close() {
    this.dialog = false;
    this.createUserDialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300);
  }

  reset() {
    this.dialog = false;
    this.createUserDialog = false;

    this.editedIndex = -1;
    this.editedItem = {};
    this.defaultItem = {};
  }
}
